import i18n from '@/i18n'
import { COMPANY_ADMIN_MENU_GROUP_KEY } from '@/constant/company'
import Index from './index.vue'
import Layout from '../layout.vue'
import SourceChannelList from './channel/list.vue'
import SourceCodeList from './sourceCode/list.vue'
import SourceChannelEditor from './channel/editor.vue'
import SourceCodeEditor from './sourceCode/editor.vue'

const basePath = '/v-admin/source-channel/management'

export default {
  name: 'companySourceChannelManagement',
  path: `${basePath}`,
  redirect: `${basePath}/channel`,
  component: Layout,
  meta: {
    isNewPage: true,
    isAllInclude: true,
    permission: 'PERM_COMPANY_SOURCING_CHANNEL_MANAGEMENT',
    titleI18nKey: 'admin.company.sourceChannelManagement.title',
    menu: {
      get label () {
        return i18n.t('admin.company.sourceChannelManagement.menu')
      },
      group: COMPANY_ADMIN_MENU_GROUP_KEY.RECRUIT
    }
  },
  children: [
    {
      path: `${basePath}/channel`,
      component: Index,
      meta: {
        permission: 'PERM_COMPANY_SOURCING_CHANNEL_MANAGEMENT',
        titleI18nKey: 'admin.company.sourceChannelManagement.tab.channelManagement',
        breadcrumb: { hidden: true }
      },
      children: [
        {
          path: `${basePath}/channel`,
          component: SourceChannelList,
          meta: {
            breadcrumb: { hidden: true },
            permission: 'PERM_COMPANY_SOURCING_CHANNEL_MANAGEMENT',
            titleI18nKey: 'admin.company.sourceChannelManagement.tab.channelManagement'
          }
        },
        {
          path: `${basePath}/code`,
          component: SourceCodeList,
          meta: {
            breadcrumb: { hidden: true },
            permission: 'PERM_COMPANY_SOURCING_CHANNEL_MANAGEMENT',
            titleI18nKey: 'admin.company.sourceChannelManagement.tab.channelManagement'
          }
        }
      ]
    },
    {
      path: `${basePath}/channel/add`,
      component: SourceChannelEditor,
      meta: {
        isEditMode: false,
        permission: 'PERM_COMPANY_SOURCING_CHANNEL_MANAGEMENT',
        titleI18nKey: 'admin.company.sourceChannelManagement.tab.channelAdd'
      }
    },
    {
      path: `${basePath}/code/edit/:codeId`,
      component: SourceCodeEditor,
      meta: {
        isEditMode: true,
        permission: 'PERM_COMPANY_SOURCING_CHANNEL_MANAGEMENT',
        titleI18nKey: 'admin.company.sourceChannelManagement.tab.sourceCodeEdit'
      }
    },
    {
      path: `${basePath}/code/add`,
      component: SourceCodeEditor,
      meta: {
        isEditMode: false,
        permission: 'PERM_COMPANY_SOURCING_CHANNEL_MANAGEMENT',
        titleI18nKey: 'admin.company.sourceChannelManagement.tab.sourceCodeAdd'
      }
    }
  ]
}
